// Version : 1.0.0
// Author : AGALYA
import axios from 'axios';
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** BANK DETAILS CREATE START *********************** */
export const basnkMemberDetailsAdd = (verifyData: any) => {
	const data = {
		CreateMemberBankDetailsToken: verifyData,
	};
	const url = `${API_URL}addBankDetails`;
	return makeApiCall(url, data);
};
/** ***************** BANK DETAILS CREATE END *********************** */

/** ***************** BANK IFSC CODE RESPONSE START *********************** */
// export const BankIFSCCreate = (BankIFSCData: any) => {
//  const url = `https://ifsc.razorpay.com/${BankIFSCData}`;
//  return makeApiCall(url, null, "GET");
// };
// NOT WORKING MAKEAPICALL WITH EXTERNAL URL SO USED AXIOS DIRECTLY HERE -NANDHAKUMAR
export const BankIFSCCreate = (BankIFSCData: any) => {
	const url = `https://ifsc.razorpay.com/${BankIFSCData}`;
	return axios.get(url);
};

/** ***************** BANK IFSC CODE RESPONSE END *********************** */
